import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgViewOnlyicon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 14,
	viewBox: "0 0 24 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M23.5 7C23.5 7 18.35 13.5 12 13.5C5.65 13.5 0.5 7 0.5 7C0.5 7 5.65 0.5 12 0.5C18.35 0.5 23.5 7 23.5 7Z",
			fill: "#DAD9EF",
			stroke: "#7284FA",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 11C14.2091 11 16 9.20914 16 7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7C8 9.20914 9.79086 11 12 11Z",
			fill: "#DAD9EF",
			stroke: "#7284FA",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 5C13.1 5 14 5.9 14 7C14 8.1 13.1 9 12 9C10.9 9 10 8.1 10 7",
			fill: "#DAD9EF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 5C13.1 5 14 5.9 14 7C14 8.1 13.1 9 12 9C10.9 9 10 8.1 10 7",
			stroke: "#7284FA",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgViewOnlyicon;
